(function () {
  if (window.__qtyDiscountInit) return;
  window.__qtyDiscountInit = true;

  function updateBanner(banner, qty) {
    var tiers = banner.querySelectorAll('.quantity-discount-tiers li');
    var activeTier = null;
    tiers.forEach(function (li) {
      var min = parseInt(li.getAttribute('data-min-qty'), 10) || 0;
      var maxAttr = li.getAttribute('data-max-qty');
      var max = maxAttr ? parseInt(maxAttr, 10) : Infinity;
      var isActive = qty >= min && qty <= max;
      li.style.fontWeight = isActive ? '700' : '400';
      li.style.color = isActive ? 'rgb(var(--color-foreground))' : '';
      if (isActive) activeTier = li;
    });
    var note = banner.querySelector('.quantity-discount-active-note');
    if (!note) return;
    if (activeTier) {
      var pct = activeTier.getAttribute('data-percent');
      note.textContent = '✓ Dein Rabatt von ' + pct + '% wird automatisch im Warenkorb abgezogen!';
      note.style.display = 'block';
    } else {
      note.style.display = 'none';
    }
  }

  function handle(event) {
    var input = event.target;
    if (!input || input.name !== 'quantity') return;
    var form = input.form;
    if (!form) return;
    var banner = form.querySelector('.quantity-discount-banner');
    if (!banner) return;
    var qty = parseInt(input.value, 10) || 1;
    updateBanner(banner, qty);
  }

  document.addEventListener('input', handle, true);
  document.addEventListener('change', handle, true);

  function initAll() {
    document.querySelectorAll('.quantity-discount-banner').forEach(function (banner) {
      var form = banner.closest('form');
      var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      updateBanner(banner, qty);
    });
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }
})();
